<template>
  <div class="regular-header">
  <navbar />

  <halfBanner>
    <template v-slot:intro-tekst>
      <h1>First Energy Gum</h1>
      <p>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."</p>
      <a v-scroll-to="'#contact'">Read more!</a>
    </template>

    <template v-slot:intro-animation>
        <div class="intro-animation">
          <lottie :options="headerImages[0].defaultOptions"/>    
          <a> {{ headerImages[headerIndex].string }}  </a>
        </div>
    </template>

  </halfBanner>  

<div class="case-page">
</div>
<footerComponent></footerComponent>

</div>

</template>

<script>
import navbar from '@/components/generalLayout/navbar.vue';
import halfBanner from '@/components/generalLayout/halfBanner.vue';
import scissorsButton from '@/components/generalLayout/scissorsButton.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';

import Lottie from '../../lottie.vue';
import * as animationFirstEnergyGum from '@/assets/cases/firstenenergygum/headeranimatie/firstenergygum.json';


export default {
    data () {
    return {
      headerImages: [
	      { defaultOptions: {animationData: animationFirstEnergyGum.default}, string:'Animatie', },
      ],
    }
  },
  components:{
    navbar,
    halfBanner,
    scissorsButton,
    footerComponent,
    'lottie': Lottie,
  },

  methods:{
    randomNumber(maxValue){
      return Math.floor(Math.random() * Math.floor(maxValue));
    }
  },
  computed:{
    headerIndex(){
      return this.randomNumber(this.headerImages.length);
    }
  },
}


</script>

<style lang="scss">

.home-bg-color{
  background: rgba(255,217,222,0.45) !important;
  background-repeat: no-repeat;
  background-size: cover;
}

.fold-container .first-content .intro-tekst{
  animation-delay: 1.4s;
}

.regular-header .fold-container .home-bg-color{
  animation-delay: .6s;
}

.regular-header .fold-container .case-hightlight-img .intro-animation{
  animation-delay: 1s;
}

@media screen and (max-width: 720px) {
  .content-grid-two-rows{
    .firstenergy, .loud, .newschain, .tca{
      float: none;
    }
  }
}

@media screen and (max-width: 640px) {
  body .case .img-box img, .odd-even-grid .text-box img{
    max-width: 90% !important;
  }
  .home-bg-color{
    width: 100% !important;
    max-width: 100% !important;
    left:12px;
    border-right: 24px solid $white !important;
  }
}

</style>
